import { Button, IconButton } from '@teo/components';
import { Fragment } from 'react';
import {
  ChevronLeft,
  ChevronRight,
  MoreHorizontal,
} from '@teo/components/icons';

function PaginationNew({
  setOffset,
  offset,
  count,
  page,
  maxPage,
  organisation,
}: any) {
  const arr = Array(maxPage)
    .fill(null)
    .map((_, i) => i + 1);

  const view = 1;
  const maxView = 3;
  const endView = 2;

  return (
    <div
      className={`mx-auto  my-4 flex w-full  max-w-xs items-center justify-center ${
        !organisation ? 'lg:w-auto' : 'px-3'
      } lg:max-w-lg 
      ${
        maxPage > 3
          ? maxPage > 6
            ? maxPage > 12
              ? 'lg:min-w-[420px]'
              : 'lg:min-w-[400px]'
            : 'lg:min-w-[350px] '
          : ''
      }`}
    >
      <IconButton
        Icon={ChevronLeft}
        variant="outline"
        onClick={() => setOffset(Math.max(offset - count, 0))}
        size="md"
        className="mr-auto"
        disabled={page === 1}
      />
      <div className="mx-2 flex w-full items-center justify-center gap-1">
        {arr?.map((el: number, index) => {
          return el === 1 ||
            el === maxPage ||
            (page <= el + view && page >= el - view) ? (
            <Fragment key={`${el}_${index}` as string}>
              {page > maxView && el === page - view && (
                <span className="mx-auto flex">
                  <MoreHorizontal className="mx-2 mt-auto mb-1 hidden w-5 lg:block" />
                </span>
              )}
              <span className="flex">
                <Button
                  variant="ghost"
                  onClick={() => {
                    setOffset((el - 1) * count, el * count);
                  }}
                  key={index}
                  disabled={page === el}
                  size="md"
                  className={`hidden lg:block ${
                    page === el && '!bg-grey-02 !text-black'
                  }`}
                >
                  {el}
                </Button>
              </span>
              {page < maxPage - endView && el === page + view && (
                <span className="mx-auto flex">
                  <MoreHorizontal className="mx-2 mt-auto mb-1 hidden w-5 lg:block" />
                </span>
              )}
            </Fragment>
          ) : (
            ''
          );
        })}
        {/* &nbsp;{page}/{maxPage}&nbsp; */}
      </div>

      <IconButton
        Icon={ChevronRight}
        variant="outline"
        onClick={() =>
          setOffset(Math.min(offset + count, (maxPage - 1) * count))
        }
        size="md"
        disabled={page === maxPage}
        className="ml-auto"
      />
    </div>
  );
}

export default PaginationNew;
